import React from 'react';
import type {ItemFormValues, UseItemForm} from '../../hooks/useItemForm';
import {CheckboxField, FieldRow, TextField} from './ItemFormControls';

export interface ItemFormLifecycleProps {
    values: ItemFormValues;
    setField: UseItemForm['setField'];
}

/**
 * Жизненный цикл вещи: когда куплена, когда утилизирована. При создании вещи
 * секция не показывается вовсе — новая вещь не может быть уже выброшена
 * (QA-13: дата утилизации и флаг «Выброшено» пугали на первом экране).
 */
const ItemFormLifecycle: React.FC<ItemFormLifecycleProps> = ({values, setField}) => (
    <>
        <FieldRow>
            <TextField
                id="item-purchase-date"
                label="Дата покупки"
                type="date"
                value={values.purchaseDate}
                onChange={v => setField('purchaseDate', v)}
            />
            <TextField
                id="item-disposal-date"
                label="Дата утилизации"
                type="date"
                value={values.disposalDate}
                onChange={v => setField('disposalDate', v)}
            />
        </FieldRow>
        <CheckboxField
            id="item-thrown-away"
            label="Выброшено"
            checked={values.thrownAway}
            onChange={v => setField('thrownAway', v)}
        />
    </>
);

export default ItemFormLifecycle;
